import script from "./GgmsRichTextEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./GgmsRichTextEditor.vue?vue&type=script&setup=true&lang=ts"

import "./GgmsRichTextEditor.vue?vue&type=style&index=0&id=e34a38f2&scoped%3Adeep=true&lang=css"

const __exports__ = script;

export default __exports__